import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pqCommonAndSubSoftHyphen',
    standalone: false
})
export class CommonAndSubjectsSoftHyphenPipe implements PipeTransform {

  public commonAndSubSoftHyphenObject: Object[] = [
    {key: 'Environmental Issues', value: 'Environ&shy;mental Issues'},
    {key: 'Science & Mathematics', value: 'Science &<br> Mathe&shy;matics'},
    {key: 'Controversial Issues', value: 'Contro&shy;versial Issues'},
    {key: 'Performing & Visual Arts', value: 'Perform&shy;ing & Visual Arts'}
  ];

  public transform (label)  {
   let matched = this.commonAndSubSoftHyphenObject.find((obj) => obj['key'] === label);
   if (matched && typeof matched !== 'undefined') {
     return matched['value'];
   } else {
    return label;
   }
  }
}
